import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SalesPage from "./pages/SalesPage";
import ThankYou from "./pages/ThankYou";
import { ContentProvider } from "./context/ContentContext";
import { AdminAuthProvider } from "./admin/AdminAuthContext";
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/pages/Dashboard";
import ProductsAdmin from "./admin/pages/ProductsAdmin";
import TestimonialsAdmin from "./admin/pages/TestimonialsAdmin";
import CmsAdmin from "./admin/pages/CmsAdmin";
import MediaAdmin from "./admin/pages/MediaAdmin";
import OrdersAdmin from "./admin/pages/OrdersAdmin";
import LeadsAdmin from "./admin/pages/LeadsAdmin";
import PaymentsAdmin from "./admin/pages/PaymentsAdmin";
import ChangePassword from "./admin/pages/ChangePassword";
import { Toaster } from "./components/ui/sonner";

function PublicSite() {
  return (
    <ContentProvider>
      <Routes>
        <Route path="/" element={<SalesPage />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </ContentProvider>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="products" element={<ProductsAdmin />} />
              <Route path="testimonials" element={<TestimonialsAdmin />} />
              <Route path="content" element={<CmsAdmin />} />
              <Route path="media" element={<MediaAdmin />} />
              <Route path="orders" element={<OrdersAdmin />} />
              <Route path="leads" element={<LeadsAdmin />} />
              <Route path="payments" element={<PaymentsAdmin />} />
              <Route path="settings" element={<ChangePassword />} />
            </Route>
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
